import React, { useCallback } from 'react';
import styled from 'styled-components';
import Typography from 'kingpin/atoms/Typography';

import { ReactComponent as NoSearchIcon } from '../images/no-search.svg';
import useIsEnabled from '../hooks/useIsEnabled';

const WrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 160px;
`;

const SubTextDiv = styled.div`
  margin-top: 8px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  text-align: center;
`;

const InlineLink = styled.span`
  color: var(--color-status-info);
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const NoSearchResults = ({
  searchText,
  isActiveFilterDisabled,
  setIsActiveFilterDisabled,
}: {
  searchText: string;
  isActiveFilterDisabled: boolean;
  setIsActiveFilterDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const hasEntities = useIsEnabled();
  const onShowInactiveClicked = useCallback(() => {
    setIsActiveFilterDisabled(true);
  }, [setIsActiveFilterDisabled]);

  const trimmed = searchText.trim();
  const hasSearch = trimmed.length > 0;

  return (
    <WrapperDiv>
      <div style={{ marginBottom: 16 }}>
        <NoSearchIcon
          width={64}
          height={64}
          color={'var(--color-icon-tertiary)'}
        />
      </div>

      <Typography.Header type="H2">
        {hasSearch ? `No results found for "${trimmed}"` : 'No results found'}
      </Typography.Header>

      <SubTextDiv>
        {!hasEntities ? (
          <Typography.Body type="Label 14">
            Try searching for something else.
          </Typography.Body>
        ) : !isActiveFilterDisabled ? (
          <Typography.Body type="Label 14">
            Try searching for something else, or{' '}
            <InlineLink onClick={onShowInactiveClicked}>
              show inactive results
            </InlineLink>
            .
          </Typography.Body>
        ) : (
          <Typography.Body type="Label 14">
            We still couldn’t find anything - even including inactive results.
          </Typography.Body>
        )}
      </SubTextDiv>
    </WrapperDiv>
  );
};

export default NoSearchResults;
